import { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UserLevel, ListType } from "routes/analysis/types/analysis";
import { ActiveFilters } from "components/layout/filters/filters";
import UserMatches from "../userMatches";
import { TestInfo } from "routes/analysis/helpers/analysisHelpers";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { PwCJwt } from "types/common";
import { UserData, TestData } from "routes/analysis/types/user";

interface UserTestsProps {
  businessProcesses?: string[];
  userData?: UserData;
}

const UserTests: FC<UserTestsProps> = ({ businessProcesses, userData }) => {
  const { testId } = useParams();

  const [openProcess, setOpenProcess] = useState<string>(userData?.tests.find(f => f.testId === testId)?.businessProcess.split(":")[1] || "");

  return (
    <>
      <ActiveFilters rows={userData?.tests.length || 0} />
      <div
        className="ap-list-header ap-business-process-header items-center flex p-4 pt-6 pb-6 gap-4"
      >
        <div className="basis-12">
        </div>
        <div className="basis-96">
          Business process
        </div>
        <div className="grow">
          Test(s) with matches
        </div>
      </div>
      {businessProcesses && businessProcesses.sort().map((process, index) => (
        <div key={process} className="list-row">
          <div
            className="flex items-center p-4 gap-4"
          >
            <div
              className="basis-12">
              <span
                onClick={() => setOpenProcess(openProcess === process ? "" : process)}
                className={openProcess === process ? "Appkit4-icon icon-down-chevron-outline pointer" : "Appkit4-icon icon-right-chevron-outline pointer"}
              />
            </div>
            <div className="basis-96">
              <b>{process}</b>
            </div>
            <div className="grow">
              <p>{userData?.tests.filter(f => f.businessProcess.split(":")[1] === process).length}</p>
            </div>
          </div>
          {
            openProcess === process && <TestDetails userData={userData} process={process} />
          }
        </div>
      ))}
    </>
  );
}

const TestDetails: FC<{ userData?: UserData, process?: string }> = ({ userData, process }) => {
  const { analysisId, userId, testId } = useParams();
  const [cookie] = useCookies();

  const checkUserLevel = (level: UserLevel) => {
    if (!cookie["id_token"]) return false;
    const jwtData = jwtDecode<PwCJwt>(cookie["id_token"]);
    return jwtData?.userLevel && UserLevel[jwtData.userLevel as keyof typeof UserLevel] !== level;
  }
  return (
    <div id={testId}>
      <div
        className="ap-list-header ap-business-process-test-header ap-accordion-open flex items-center p-5 gap-4"
      >
        <div className="basis-12">
        </div>
        <div className="basis-96">
          Test
        </div>
        <div className="basis-20">
          Test type
        </div>
        <div className="grow">
          Included function(s)
        </div>
      </div>
      {userData?.tests?.filter((f: TestData) => f.businessProcess.split(":")[1] === process).map((test, index) => (
        <div key={test.identifier} className="list-row-1">
          <Link id={test.identifier} className="pointer" to={testId === test.testId ? `/analysis/${analysisId}/user/${userId}` : `/analysis/${analysisId}/user/${userId}/test/${test.testId}#${test.identifier}`} relative="path">
            <TestInfo test={test} open={test.testId === testId} />
          </Link>
          {(testId === test.testId && checkUserLevel(UserLevel.Business)) && (
            <div className="ap-accordion-open">
              <div className="ap-wrapper-inline ap-wrapper-matches">
                <UserMatches type={ListType.Test} typeId={testId} userData={userData} />
              </div>
            </div>
          )}
        </div>
      ))
      }
    </div>
  )
}

export default UserTests;
